import { PropsWithChildren, useMemo } from 'react'

import { getCountriesAction } from '@percent/education-hosted-form/api/countries/countries.actions'
import { CountriesContext } from './CountriesContext'
import { useQuery } from '@percent/education-hosted-form/hooks/useQuery/useQuery'
import { useEducationHostedForm } from '@percent/education-hosted-form/hooks/useEducationHostedForm/useEducationHostedForm'

export function CountriesContextController({ children }: PropsWithChildren) {
  const { partnerConfig } = useEducationHostedForm()

  const { data: countries, isError } = useQuery(['countries'], getCountriesAction, {
    enabled: !!partnerConfig
  })

  const contextValue = useMemo(() => ({ countries: countries?.data ?? [], isError }), [countries, isError])

  return <CountriesContext.Provider value={contextValue}>{children}</CountriesContext.Provider>
}
